import './HtmlEditor.css'
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertFromRaw, ContentState, convertFromHTML } from 'draft-js';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'

function HtmlEditor({ height = '300px', width = '100%', ...rest }, ref) {
    const editorContainerRef = useRef()
    const [currentEditorState, setCurrentEditorState] = useState(null)


    useEffect(
        () => {
            let contentConvert = convertFromHTML(rest?.value)
            let inicialEditorState = EditorState.createWithContent(ContentState.createFromBlockArray(contentConvert.contentBlocks, contentConvert.entityMap))
            setCurrentEditorState(inicialEditorState)
        },
        []
    )


    useImperativeHandle(ref, () => {
        return {
            getEditorInnerText: getEditorInnerText,
            getEditorInnerHTML: getEditorInnerHTML,
            cleanData: cleanData
        }
    })

    function cleanData() {
        // editorContainerRef.current.children[0].children[1].innerText = ''
    }

    function getEditorInnerText() {
        return String(editorContainerRef.current.children[0].children[1].innerText ?? '').trim()
    }

    function getEditorInnerHTML() {
        return String(editorContainerRef.current.children[0].children[1].innerHTML ?? '').trim()
    }

    return (
        //para funcionar a toolbar de link precisamos desativar o strict mode do react.
        <div ref={editorContainerRef} style={{ height, width }}>
            <Editor 
            toolbar={{
                options: ['inline', 'list', 'link', 'history'],
            }}
            editorState={currentEditorState} onEditorStateChange={setCurrentEditorState} {...rest}/>
        </div>
    )
}

export const SL_HtmlEditor = forwardRef(HtmlEditor)
